<h5 *ngIf="!dataSource || dataSource.length==0">No spare parts in the package</h5>

<table *ngIf="dataSource && dataSource.length>0" mat-table [dataSource]="dataSource" class="mat-elevation-z2">
  <ng-container matColumnDef="PartNumber">
    <th mat-header-cell *matHeaderCellDef><strong> Part Number </strong></th>
    <td mat-cell *matCellDef="let element"> {{element.PartNumber}} </td>
  </ng-container>

  <ng-container matColumnDef="Description">
    <th mat-header-cell *matHeaderCellDef><strong> Description </strong></th>
    <td mat-cell *matCellDef="let element"> {{element.Description}} </td>
  </ng-container>

  <ng-container matColumnDef="TechData">
    <th mat-header-cell *matHeaderCellDef><strong> Tech Data </strong></th>
    <td mat-cell *matCellDef="let element"> {{element.TechData}} </td>
  </ng-container>

  <ng-container matColumnDef="EstimatedPmHours">
    <th mat-header-cell *matHeaderCellDef><strong> Estimated PM Hours</strong></th>
    <td mat-cell *matCellDef="let element"> {{element.EstimatedPmHours}} </td>
  </ng-container>

  <ng-container matColumnDef="Quantity">
    <th mat-header-cell *matHeaderCellDef><strong> Quantity </strong></th>
    <td mat-cell *matCellDef="let element"> {{element.Quantity}} </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <a mat-raised-button color="primary" routerLink="/spare-part/{{element.Id}}">
        <mat-icon>info</mat-icon>
        Details
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>